export const environment = {
  appName: "HHEO",
  production: true,
  serverUrl:
    "https://hheo-gateway-stg.politewave-7a937208.uaenorth.azurecontainerapps.io",
  surveyServerUrl:
    "https://hheo-surveys-portal-stg.politewave-7a937208.uaenorth.azurecontainerapps.io/identity/login",
  serverUrlLoyalty:
    "https://hheo-loyalty-program-d6abczawfufdchgj.uaenorth-01.azurewebsites.net/api",
  globalSatisfactionDashboardUrl: '',

  env: "Staging",
  version: "5.0",
  defaultLang: "en",
};
